import PropTypes from 'prop-types';
import { m } from 'framer-motion';
// @mui
import { alpha, useTheme, styled } from '@mui/material/styles';
import { Box, Grid, Button, Container, Typography, LinearProgress, Stack, TextField } from '@mui/material';
// hooks
import useResponsive from 'src/hooks/useResponsive';
// utils
import { fPercent } from 'src/utils/formatNumber';
// _mock_
import { _skills } from 'src/_mock';
// components
import Image from 'src/components/Image';
import Iconify from 'src/components/Iconify';
import { MotionViewport, varFade } from 'src/components/animate';
import img1 from 'src/assets/images/what-1.jpg'
import img2 from 'src/assets/images/what-2.jpg'
import { useState } from 'react';
// import { eduleyApi } from 'src/api/apiConfig';
import { API_ENDPOINTS } from 'src/api/apiEndPoints';
import axios from 'axios';
import { useSnackbar } from 'notistack';
// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
    textAlign: 'center',
    paddingTop: theme.spacing(20),
    paddingBottom: theme.spacing(10),
    [theme.breakpoints.up('md')]: {
        textAlign: 'left',
    },
}));

// ----------------------------------------------------------------------

export default function InstituteLogin({ gotoback }) {
    const theme = useTheme();
    const { enqueueSnackbar } = useSnackbar()

    const isDesktop = useResponsive('up', 'md');

    const isLight = theme.palette.mode === 'light';

    const shadow = `-40px 40px 80px ${alpha(isLight ? theme.palette.grey[500] : theme.palette.common.black, 0.48)}`;
    const [email, setEmail] = useState('')
    const [error, setErroe] = useState('')
    const config = {
        headers: {
            "Content-Type": "application/json",
            //   Authorization: `Bearer ${accessToken}`,
        },
    };
    const gotoiappage = async () => {
        if (email == '') {
            enqueueSnackbar('please enter your login email', { variant: 'error' })
            return
        }
        try {

            let res = await axios.get(API_ENDPOINTS.GET_INSTITUTE + '?email=' + email, config,)
            // let res = await axios.post(API_ENDPOINTS.API_URL + '/admin/login/', config, data)

            window.location.href = res.data

        } catch (error) {
            enqueueSnackbar(error.response?.data?.email || 'error', { variant: 'error' })
            console.log(error.response)

        }
    }
    return (<>
        <Grid container spacing={3} alignItems="flex-end">
            <Grid item md={4}>
                <Button
                    onClick={() => gotoback()}
                    fullWidth
                    color="primary"
                    size="large"
                    startIcon={<Iconify icon={'fa:long-arrow-left'} width={24} height={24} />}
                >
                    Back
                </Button>
            </Grid>
        </Grid>
        {/* <m.div variants={varFade().inUp}> */}
        <Typography variant="h4" sx={{ mb: 1, mt: 3 }}>
            Institute Login Page
        </Typography>
        {/* </m.div> */}
        {/* <m.div variants={varFade().inRight}> */}
        <Typography
            sx={{
                color: (theme) => (theme.palette.mode === 'light' ? 'text.secondary' : 'common.white'),
            }}

        >
            Enter your login email address
        </Typography>
        {/* </m.div> */}
        {/* <m.div variants={varFade().inRight}> */}
        <Typography
            variant='caption'
            sx={{
                color: (theme) => (theme.palette.mode === 'light' ? 'text.secondary' : 'common.white'),
            }}
        >
            will check your email and take to your institute admin panel
        </Typography>
        {/* </m.div> */}
        <Grid container sx={{ mt: 0.01 }} spacing={3}>
            <Grid item md={8}>

                <TextField
                    fullWidth
                    onChange={e => setEmail(e.target.value)}
                    value={email}
                    placeholder={'Enter your email'}
                />
            </Grid>
            <Grid item md={4}>

                <Button
                    onClick={() => gotoiappage()}
                    fullWidth
                    variant="contained"
                    color="primary"
                    size="large"
                    endIcon={<Iconify icon={'ic:round-arrow-right-alt'} width={24} height={24} />}
                >
                    Next
                </Button>
            </Grid>
        </Grid>


    </>
    );
}

// ----------------------------------------------------------------------

ProgressItem.propTypes = {
    progress: PropTypes.shape({
        label: PropTypes.string,
        value: PropTypes.number,
    }),
};

function ProgressItem({ progress }) {
    const { label, value } = progress;

    return (
        <Box sx={{ mt: 3 }}>
            <Box sx={{ mb: 1.5, display: 'flex', alignItems: 'center' }}>
                <Typography variant="subtitle2">{label}&nbsp;-&nbsp;</Typography>
                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                    {fPercent(value)}
                </Typography>
            </Box>
            <LinearProgress
                variant="determinate"
                value={value}
                sx={{
                    '& .MuiLinearProgress-bar': { bgcolor: 'grey.700' },
                    '&.MuiLinearProgress-determinate': { bgcolor: 'divider' },
                }}
            />
        </Box>
    );
}
